import Vue from 'vue';
import TombolaBaseComponent from '@/components/base/base.component';
import { Component, Prop } from 'vue-property-decorator';
import { IGameController } from '@/components/game/_domain/models/game-controller';
import { IGameRepresentationChangedArgs } from '@/components/game/_domain/models';

@Component({
  name: 'CallCounterComponent'
})
export default class CallCounterComponent extends TombolaBaseComponent {
  @Prop() public gameController: IGameController;
  @Prop() public callBoardName: string;
  private callNumber: number = null;
  private maxNumberOfCallsPerGame: number = null;

  private get currentCallNumber(): string {
    if (this.callNumber) {
      return `${this.callNumber} of ${this.maxNumberOfCallsPerGame}`;
    }
    return '';
  }

  private mounted() {
    const game = this.gameController.getGame();
    this.maxNumberOfCallsPerGame = game.gameConfiguration.maxNumberOfCallsPerGame;

    Vue.nextTick(() => {
      this.gameController.onGameRepresentationChanged(this.handleGameRepresentationChanged);
    });
  }

  private handleGameRepresentationChanged(eventArgs: IGameRepresentationChangedArgs) {
    const gameRepresentation = eventArgs.currentGameRepresentation;

    switch (this.callBoardName){
      case 'wordsearch':
        this.callNumber = gameRepresentation.wordSearchCallBoard.currentCallNumber;
        break;
      default:
        this.callNumber = gameRepresentation.callboard.currentCallNumber;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/_default/_components/call-counter/call-counter.component.ts